module.exports = __webpack_public_path__ + "static/media/psychometric_start_meals2.4b745223.jpg";